import { render, staticRenderFns } from "./ValidationError.vue?vue&type=template&id=5ab0d88e&"
import script from "./ValidationError.vue?vue&type=script&lang=js&"
export * from "./ValidationError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports